<form [formGroup]="form" style="display: flex; flex-direction: row; gap: 8px; width: 100%">
  <mat-form-field class="filter-input" appearance="outline">
    <button mat-icon-button matPrefix (click)="search()">
      <mat-icon>search</mat-icon>
    </button>
    <mat-label>Search</mat-label>
    <input
      #searchInput
      id="searchInput"
      matInput
      (keyup.enter)="search()"
      (keyup.backspace)="checkForClear()"
      placeholder="Search for a course"
    />
  </mat-form-field>
</form>
